import {Directive, Input, ElementRef, OnInit, HostBinding, HostListener, Output, EventEmitter} from '@angular/core';


declare var $: any;

@Directive({
  selector: '[saBootstrapValidator]'
})
export class BootstrapValidatorDirective implements OnInit {

  @Input() saBootstrapValidator:any;
    @Output()
    afterValidate: EventEmitter<boolean> = new EventEmitter<boolean>();


    @HostListener('submit') s = () => {
    const bootstrapValidator = this.$form.data('bootstrapValidator');
    bootstrapValidator.validate();
        if (bootstrapValidator.isValid()) {
            this.afterValidate.emit(true);
            //this.$form.submit();
        }
        else {
            this.afterValidate.emit(false);
            return;
        }
  }

  constructor(private el:ElementRef) {

  }

  ngOnInit(){
    System.import('script-loader!smartadmin-plugins/bower_components/bootstrapvalidator/dist/js/bootstrapValidator.min.js').then(()=> {
      this.attach()
    })
  }

  private $form: any;


  private attach() {

    this.$form = $(this.el.nativeElement)
    this.$form.bootstrapValidator(this.saBootstrapValidator || {})

    this.$form.submit(function(ev){ev.preventDefault();});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/forms/validation/bootstrap-validator.directive.ts